// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useEffect, useState } from "react";

import { mdiOneUp } from "@mdi/js";
import { Alert, Button, Popover, Select } from "antd";
import styled from "styled-components";

import { useGetPlaysList } from "components/tools/hooks";

import { ShapefileAction } from "../..";
import ShapefilePromoteOverwriteSelection from "./ShapefilePromoteOverwriteSelection";

interface IShapefilePromoteProps {
  isDisabled?: boolean;
  closePopover: () => void;
  promoteShapefile: (play: string, shapefileToOverwrite: string) => void;
}

export function ShapefilePromoteAction({
  isDisabled,
  closePopover,
  promoteShapefile
}: IShapefilePromoteProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [selectedPlay, setSelectedPlay] = useState<string>(null);
  const [shapefileToOverwrite, setShapefileToOverwrite] = useState(null);

  const { data, mutate } = useGetPlaysList();

  useEffect(() => {
    mutate();
  }, []);

  const playList = data?.map((play) => ({ label: play, value: play })) ?? [];
  const playOptions = [
    { label: "", value: null },
    { label: "All", value: "All" },
    ...playList
  ];

  const onClose = () => {
    setIsPopoverOpen(false);
    closePopover();
    setSelectedPlay(null);
    setShapefileToOverwrite(null);
  };

  const promoteMenu = (
    <PromoteMenu>
      <PlaySelector
        options={playOptions}
        placeholder="Select Play"
        onChange={(value) => setSelectedPlay(value)}
        value={selectedPlay} // show placeholder if empty string
        showSearch={true}
      />
      {!selectedPlay && (
        <WarningAlert
          message="Warning: No play selected"
          type="warning"
          showIcon={true}
        />
      )}
      <ShapefilePromoteOverwriteSelection
        shapefileToOverwrite={shapefileToOverwrite}
        setShapefileToOverwrite={setShapefileToOverwrite}
      />
      <PromoteButtons>
        <Button onClick={onClose}>Cancel</Button>
        <SubmitButton
          onClick={() => {
            promoteShapefile(selectedPlay ?? "", shapefileToOverwrite?.shapefileId);
            onClose();
          }}>
          Submit
        </SubmitButton>
      </PromoteButtons>
    </PromoteMenu>
  );
  return (
    <Popover
      open={isPopoverOpen}
      onOpenChange={(open) => setIsPopoverOpen(open)}
      placement="right"
      trigger="click"
      content={promoteMenu}
      title={`Promote Shapefile to System/McDan Shapefile`}>
      <ShapefileAction disabled={isDisabled}>
        <Icon path={mdiOneUp} size={"18px"} />
        Promote
      </ShapefileAction>
    </Popover>
  );
}

const PromoteMenu = styled.div`
  width: 300px;
`;

const PlaySelector = styled(Select)`
  width: 100%;
  margin-bottom: 10px;
`;

const WarningAlert = styled(Alert)`
  margin-bottom: 5px;
`;

const PromoteButtons = styled.div`
  display: flex;
  justify-content: right;
`;

const SubmitButton = styled(Button)`
  background-color: var(--color-primary);
  color: white;
`;
